<template>
 <bernstein-layout >
          <Head title="Addison Export " />
            <div class="container mx-auto font-family:ui-serif,Georgia, Cambria justify-center" >
                   <form @submit.prevent="submit" class="flex flex-col justify-center mx-auto mb-2 md:w-1/2 "  >
                        <h1 class="text-2xl font-bold text-gray-900 p-2 mb-4 text-center"> 
                          DHL FREIGHT Upload 

                        </h1>
                              <!-- Start of success message  -->
                          <div v-if= "this.form.submitted" class="py-4 mb-4 text-red-700 font-extrabold">  
                                  {{$page.props.flash.message}}
                          </div>
                               <!-- start of icon  -->
                            <div v-if="form.processing" class="flex flex-wrap items-center space-x-3">
                                  <p class="text-red-600 py-2 font-bold" > 
                                          Datei wird versendet !
                                  </p>
                                  <div class="p-2 my-2"> 
                                  <!-- {{downloadIcon}}  -->
                                  <!-- <img :src="downloadIcon" />  -->
                                      <img :src="downloadIcon" 
                                      alt="HTML5 Icon" width="250" height="250">
                                  </div> 
                            </div>
                        <!-- anzahlung_rechnung  -->     
                        <div class="flex flex-col  py-2 mb-1">
                            <!-- <label class="text-gray-900 font-semibold block my-3 text-lg  w-1/3" 
                            for="dhl_file">Anzahlung Rechnung</label> -->
                            <input class=" w-2/3 bg-gray-100 px-4 py-2 rounded-lg focus:outline-none  text-center
                                    transition
                                    ease-in-out
                                    m-0" 
                                type="file"
                                @input ="form.dhl_file=$event.target.files[0]" 
                                step="any"
                                name="dhl_file" 
                                id="dhl_file" 
                                /> 
                            <!-- progress bar  -->
                        
                        
                        </div>
                        
                                         
                <!-- Speichern  -->
                 	<button type="submit" 
                     class="w-full mt-6 bg-indigo-600 rounded-lg px-4 py-2 text-lg text-white 
                        tracking-wide font-semibold font-sans mb-4">Speichern</button>
				
                    </form>
            </div> 
   
 </bernstein-layout > 
</template>
<script>
import BernsteinLayout from '@/Layouts/BernsteinLayout.vue'
import { Head, Link } from '@inertiajs/inertia-vue3';
import { reactive } from 'vue'
import { Inertia } from '@inertiajs/inertia'
export default {
  props:{
        message: String,
        downloadIcon:String,
     },
    components:{
        BernsteinLayout,
        Head,
       Link
    },
    data(){
        return {
           form: this.$inertia.form({
                    _method: 'PUT',
                     dhl_file:null,
                     processing: false,
                     submitted: false
                }),
               
        }
    },
  //     setup () {
  //   const form = reactive({
  //       processing: false,
  //       dhl_file:null,
     



  //   })

  //   function submit() {
  //      this.form.processing=true;
  //     Inertia.post('/dhl/uploads', form)
  //   }

  //   return { form, submit }
  // },
    
  methods:{
      submit (){
          this.form.processing=true;          
          this.form.post(route('dhl.store'), {
                    // errorBag: 'updateProfileInformation',
                    preserveScroll: true,
                    // resetOnSuccess: false,
                     onSuccess: (response) => (this.showResponse (response)), 
                   
                },
                {
                    
                });
      },
      showResponse(response){
        //   alert("test");
        // console.log(response);
        this.form.processing =false;
        this.form.submitted  =true;
        // var message     = response.props.flash.message;
        // var element  = document.createElement('a');
        // element.setAttribute('href', link);
        // element.style.display = 'none';
        // document.body.appendChild(element);
        // element.click();
        // document.body.removeChild(element);
  
      }
  }
}
</script>